import { IComponentOptions, IController } from 'angular';
import { ModalService } from '../../../components/modals/gmc-modal/gmc-modal.service';
import './delete-account.component.scss';

export class DeleteAccountController implements IController {
  static $inject = [
    'ModalService'
  ];
  isDeleteBtnEnabled = false;

  constructor( private modalService: ModalService ) {
  }

  showDeleteConfirm() {
    this.isDeleteBtnEnabled = false;
    this.modalService.showModal({
      backdrop: true,
      data: {},
      extraClasses: 'modal-dialog-centered-1',
      component: 'deleteAccountModal'
    });
  }
}

export const DeleteAccountComponent: IComponentOptions = {
  controller: DeleteAccountController,
  template: require('./delete-account.component.html'),
  bindings: {}
};



// WEBPACK FOOTER //
// ./app/shared/components/delete-account/delete-account.component.ts